import { CommonDialog, DialogContent, Text } from '@color/continuum';

export interface NoteDialogProps {
  title: string;
  note: string;
  onClose: () => void;
}

export function NoteDialog(props: NoteDialogProps) {
  const { title, note, onClose } = props;
  return (
    <CommonDialog dialogIsOpen onClose={onClose} title={title}>
      <DialogContent>
        <Text variant="body2">{note}</Text>
      </DialogContent>
    </CommonDialog>
  );
}
